<template>
  <a-flex
    v-if="column.dataIndex === 'type'"
    gap="small"
    align="center"
    justify="center"
  >
    <span>{{ column.title }}</span>

    <a-popover placement="bottom" trigger="click">
      <template #content>
        <a-flex vertical gap="small">
          <a-button
            type="text"
            v-for="item in MarkingCodesDocumentTypeOptions"
            :key="item.value"
          >
            {{ item.title }}
          </a-button>
        </a-flex>
      </template>
      <a-button type="text" :icon="h(FilterOutlined)"></a-button>
    </a-popover>
  </a-flex>

  <a-flex
    v-else-if="column.dataIndex === 'status'"
    gap="small"
    align="center"
    justify="center"
  >
    <span>{{ column.title }}</span>

    <a-popover placement="bottom" trigger="click">
      <template #content>
        <a-flex vertical gap="small">
          <a-button
            type="text"
            v-for="item in MarkingCodesDocumentStatusOptions"
            :key="item.value"
          >
            {{ item.title }}
          </a-button>
        </a-flex>
      </template>
      <a-button type="text" :icon="h(FilterOutlined)"></a-button>
    </a-popover>
  </a-flex>

  <template v-else>
    {{ column.title }}
  </template>
</template>

<script setup lang="ts">
import {
  type MarkingCodesDocumentsTableItem,
  MarkingCodesDocumentStatusOptions,
  MarkingCodesDocumentTypeOptions,
} from "@/stores/product/marking/marking-codes-documents.store";
import { h } from "vue";
import { FilterOutlined } from "@ant-design/icons-vue";

defineProps<{
  column: {
    dataIndex: keyof MarkingCodesDocumentsTableItem;
    title: string;
  };
}>();
</script>

<style scoped lang="scss">
.ant-popover {
  .ant-btn {
    width: 100%;
  }
}
</style>
